// src/components/DarkModeToggle.tsx
// import React from 'react'; // Not needed in modern React
import { useTheme } from '../hooks/useTheme';
import styles from './DarkModeToggle.module.css';

export default function DarkModeToggle() {
  const { effectiveTheme, toggleTheme } = useTheme();

  const getIcon = () => {
    return effectiveTheme === 'dark' ? '🌙' : '☀️';
  };

  const getLabel = () => {
    return effectiveTheme === 'dark' ? 'Dark' : 'Light';
  };

  const getAriaLabel = () => {
    return effectiveTheme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode';
  };

  return (
    <div className={styles.container}>
      <button
        onClick={toggleTheme}
        className={`${styles.toggleButton} ${styles[effectiveTheme]}`}
        aria-label={getAriaLabel()}
        title={getLabel()}
      >
        <span className={styles.icon}>
          {getIcon()}
        </span>
        {/* Only show label on larger screens */}
        <span className={styles.label}>
          {getLabel()}
        </span>
      </button>
    </div>
  );
}
